import React from "react";
import Facts from "./Facts";
import Skills from "./Skills";
import Resume from "./Resume";
import Contact from "./Contact";
import Portfolio from "./Portfolio";
import { BsChevronRight } from "react-icons/bs";
import { IconContext } from "react-icons/lib";
import { about, aboutShort, aboutLong } from "./data";
import TypingAnimation from './TypingAnimation';  // Import the TypingAnimation component
import ProgressBar from './ProgressBar';  // Import the ProgressBar component

export default function About() {
  // Extract the text array from aboutShort
  const typingTextArray = aboutShort.map(item => item.text);
  return (
    <main id="main">
      <section id="about" className="about">
        <div className="container">
          <div className="section-title">
            <h2>About</h2>
            <p></p>
          </div>

          <div className="row">
            <div className="col-lg-4" data-aos="fade-right">
              <img
                src="assets/img/profile-img.jpg"
                className="img-fluid"
                alt=""
              />
            </div>
            <div className="col-lg-8 pt-4 pt-lg-0 content" data-aos="fade-left">
              {/* Typing animation */}
              <TypingAnimation textArray={typingTextArray} typingSpeed={100} />

              <div className="row">
                <div className="col-lg-12">
                  <ul>
                    {about.map((aboutData) => {
                      const { id, title, value } = aboutData;
                      return (
                        <IconContext.Provider
                          key={id}  // Added key here to resolve the warning
                          value={{
                            color: "#2596be",
                            className: "global-class-name",
                          }}
                        >
                          <li>
                            <BsChevronRight />
                            <strong>{title}: </strong> <span>{value}</span>
                          </li>
                        </IconContext.Provider>
                      );
                    })}
                  </ul>
                </div>
              </div>

              {aboutLong.map((data, index) => {
                const { text } = data;
                return <p key={index}>{text}</p>;  {/* Added key here */}
              })}
            </div>
          </div>
        </div>
      <Facts />
      </section>
      <Skills />
      <Resume />
      <Portfolio />
      <Contact />
    </main>
  );
}
